// Bridges ui.ts's cast handler (which knows the cast's concept/modifiers and which
// two objects are involved) to GameScene (which owns the actual mutable object
// state) -- same cross-module-without-a-direct-reference shape as gameReset.ts and
// radialMeasure.ts, except this one needs a real return value (did anything
// physically happen, and to what), so it's a single settable handler rather than a
// listener list.
//
// The event/result shapes themselves moved to rune-lab/src/sim/casts.ts with the
// handler that consumes them (2026-07-30, sim extraction step 4b) and are
// re-exported here unchanged, so every import site still reads them from this
// module. What stays here is the bridge itself: a settable handler is UI wiring,
// not world data.
import { TransferEffectEvent, TransferEffectResult } from '../../rune-lab/src/sim/casts';

export type { TransferEffectEvent, TransferEffectResult };

type Handler = (event: TransferEffectEvent) => TransferEffectResult;

let handler: Handler | null = null;

export function onTransferEffect(fn: Handler): void {
  handler = fn;
}

export function triggerTransferEffect(event: TransferEffectEvent): TransferEffectResult {
  return handler ? handler(event) : { applied: false };
}
